import { render, staticRenderFns } from "./HaberDetay.vue?vue&type=template&id=f42abe1c&scoped=true&"
import script from "./HaberDetay.vue?vue&type=script&lang=js&"
export * from "./HaberDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42abe1c",
  null
  
)

export default component.exports